import { render } from "./PagamentoDebitoVeicularSucesso.vue?vue&type=template&id=206b32b8"
import script from "./PagamentoDebitoVeicularSucesso.vue?vue&type=script&lang=js"
export * from "./PagamentoDebitoVeicularSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__